import React from 'react'
import { Box, Typography, Button, CircularProgress } from '@mui/material'
import { useProcessStage } from './hooks'
import { getStatusTableRows, getProcessResultTableRows } from './formatUtils'
import { ReviewCorrections } from './ReviewCorrections'
import { ReviewUnchanged } from './ReviewUnchanged'
import { OpenJsonButton } from '../../utility/OpenJsonButton'
import { downloadJson } from 'shared/utils/fileExport'
import { SummaryTable } from '../../SummaryTable'

import type { StageProps } from './types'

export function ProcessStage({ treeId, versionId }: StageProps) {
  const { processStatus, processResult, handleStartStage, canStart } =
    useProcessStage(treeId, versionId)

  return (
    <Box border={1} borderColor="grey.300" borderRadius={1} p={2} mb={2}>
      <Typography variant="h6" gutterBottom sx={{ fontStyle: 'italic' }}>
        Process
      </Typography>
      <Box display="flex" alignItems="center" gap={2} mb={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleStartStage}
          disabled={!canStart}
          size="small"
        >
          Start
        </Button>
      </Box>

      {processStatus && (
        <Box sx={{ mb: 1 }}>
          {!processStatus.completed && (
            <Box sx={{ mb: 1 }}>
              <CircularProgress size={20} color="primary" />
            </Box>
          )}
          <SummaryTable
            rows={getStatusTableRows(processStatus, null)}
            firstColumnSx={{ fontStyle: 'italic' }}
          />
        </Box>
      )}

      {processResult && (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
            <OpenJsonButton
              data={processResult}
              disabled={!processResult}
              buttonText="See JSON results"
            />
            <Button
              variant="text"
              size="small"
              onClick={() => {
                downloadJson(
                  `process_results_${treeId}_${versionId}.json`,
                  processResult,
                )
              }}
              sx={{ textTransform: 'none', fontSize: '0.75rem' }}
            >
              Download JSON
            </Button>
          </Box>
          <SummaryTable
            header="Process Results"
            rows={getProcessResultTableRows(processResult)}
            firstColumnSx={{ fontStyle: 'italic' }}
          />
        </>
      )}

      {processResult && <ReviewCorrections />}
      {processResult && <ReviewUnchanged />}
    </Box>
  )
}
